import React, { memo } from 'react';

import Translation from '@swf/components/Translation/Translation';
import { Icon } from '@swf/sports/components';

import useDisplayPriceChanges from '../../hooks/useDisplayPriceChanges';
import AutoAcceptPriceChangesToggle from '../AutoAcceptPriceChangesToggle/AutoAcceptPriceChangesToggle';
import Keyboard from '../BetSlip/components/Keyboard/Keyboard';

import { TXTWCL_There_are_price_updates } from './Footer.messages.json';
import styles from './Footer.scss';
import Buttons from './components/Buttons/Buttons';
import Messages from './components/Messages/Messages';
import Totals from './components/Totals/Totals';

const Footer: React.FC<{ showTotals: boolean }> = ({ showTotals }) => {
  const { displayFooterPriceChanges } = useDisplayPriceChanges();

  return (
    <>
      <Messages />

      {displayFooterPriceChanges && (
        <div role="alertdialog" aria-labelledby="betslip-price-change-alert">
          <div className={styles.priceUpdates} id="betslip-price-change-alert">
            <Icon name="error" className={styles.icon} size="x2" />
            <Translation {...TXTWCL_There_are_price_updates} />
          </div>
        </div>
      )}

      <Keyboard />

      <div className={styles.footer} data-testid="bet-slip-footer">
        {showTotals && (
          <>
            <AutoAcceptPriceChangesToggle />
            <Totals />
          </>
        )}

        <Buttons />
      </div>
    </>
  );
};

export default memo(Footer);
